(function ($) {
  Drupal.behaviors.prod_qs_3across = {
    attach: function (context, settings) {
      // discover more
      if(page_data['list_customqs_prods'] !== undefined){
        var worksWithData = page_data['list_customqs_prods'].products;
        var $btn_quickshop = $('.discover_more__product-quickshop', context);
        $btn_quickshop.text(site.translations.product.view_details);
        $btn_quickshop.off('click').on('click', function(e) {
          e.preventDefault();
          console.log("quickshop initiated!");
          var quickshopPID = $(this).attr('data-productid');
          var quickshopData = _.find(worksWithData, function(pr){ return pr.PRODUCT_ID == quickshopPID; });

          if ($('body').hasClass('device-mobile')) {
            var productUrl = $(e.target).parent().children('.discover_more__product-url').prop('href');

            window.location.href = productUrl;
          } else {
            site.quickshop(quickshopData);
          }
        });
      }

    }// attach
  };

})(jQuery);